<template>
  <v-row justify="center">
    <v-col cols="12" md="12">
      <h1 class="mb-5" v-html="$t('menu-digital.diners_label')" v-if="instance.slug === 'circo-col-bogota' || instance.slug === 'the-market-2'" />
      <h1 v-else class="mb-5" v-html="$t('booking.invitados')" />
      <v-card class="card-number-people" dense elevation="4">
        <v-card-text class="body-card-number-people">
          <v-btn class="rounded-lg" @click="restPerson()" data-testid="PeoplePass-RestPersonBtn">
            <v-icon class="icon-plus-minus">fa-light fa-minus</v-icon>
          </v-btn>
          <span v-if="numberPeolple !== null" class="text-h3 icon-plus-minus">{{ countPersons }}</span>
          <v-btn class="rounded-lg" @click="addPerson()" data-testid="PeoplePass-AddPersonBtn">
            <v-icon class="icon-plus-minus">fa-light fa-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
    <v-dialog
      v-model="showAlertMax"
      scrollable persistent :overlay="false"
      max-width="500px" transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          Cantidad de personas
        </v-card-title>
        <v-card-text>
          <div class="draft-info">
            El número máximo de personas para esta hora es de {{ numberPeolple && numberPeolple.max != null ? numberPeolple.max : '' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="button-nextpass text-capitalize"
            color="primary" small
            @click="showAlertMax = false"
            v-html="'Cerrar'"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import { reservas } from "@/services/reservas";
import { misMixins } from "@/mixins/mixins.js";
import { mapState } from "vuex";

export default {
  name: 'PeoplePass',
  props: {
    reservation: Object,
    branch: Object,
    hora: [Object, String]
  },
  data(){
    return{
      count: null,
      numberPeolple: null,
      showAlertMax: false
    }
  },
  mixins: [ misMixins ],
  computed: {
    ...mapState('shared', ["windowSize"]),
    ...mapState('customer', ["instance"]),
    countPersons: {
      get() {
        let numberPerson = this.count;
        return numberPerson;
      },
      set(newValue) {
        if( newValue === this.numberPeolple.max + 1 ) return;
        if( newValue === this.numberPeolple.min - 1 ) return;
        this.count = newValue;
        this.reservation.cuantos = this.count;
        this.$emit('changePerson',this.reservation.cuantos)
      }
    }
  },
  watch: {
    count(val) {
      if(val !== this.reservation.cuantos) this.reservation.cuantos = val;
    },
    hora(val) {
      if(val.min_people != null) {
        this.numberPeolple.min = val.min_people;
        this.numberPeolple.max = val.max_people;

        if(this.countPersons > val.max_people) {
          this.countPersons = val.max_people;
          this.showAlertMax = true;
        } else {
          this.showAlertMax = false;
        }
      }
    }
  },
  methods: {
    cambioPaso() {
      if(this.count !== null) this.reservation.cuantos = this.count;
    },
    addPerson() {
      this.countPersons++;
      this.reservation.cuantos = this.count;
    },
    restPerson() {
      this.countPersons--;
      this.reservation.cuantos = this.count;
    },
    async getPeople(){
      try {
        const numberPeople = await reservas.getPeople();
        if(numberPeople) {
          this.numberPeolple = numberPeople.data;
          this.count = this.numberPeolple.min;
          this.reservation.peopleQuantity = numberPeople.data.people_quantity;
          this.reservation.cuantos = this.count;
          this.$emit('changePerson',this.reservation.cuantos)
        };
      } catch (error) {
        console.error(error);
      };
    }
  },
  mounted() {
    this.getPeople();
  }
}
</script>

<style scoped lang="scss">
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 40px !important;
  }
  .card-number-people {
    height: 5rem;
    border-radius: 16px !important;
    text-align: center !important;
    .body-card-number-people {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
  }
</style>